import { Component, OnInit } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { ActivatedRoute } from '@angular/router';
import { ReactiveFormsModule } from "@angular/forms";
import { FieldType } from '@ngx-formly/material';
import { DocumentDto } from 'projects/shared/src/lib/models/DocumentDto';
import { AttributeValueService } from 'projects/shared/src/lib/services/attribute-value.service';
import { DataSharingService } from 'projects/shared/src/lib/services/data-sharing.service';

@Component({
  selector: 'al-toggle-type',
  templateUrl: './al-toggle-type.component.html',
  styleUrls: ['./al-toggle-type.component.scss']
})
export class AlToggleTypeComponent extends FieldType implements OnInit {

  documentDto!: DocumentDto;

  totalRecords = 0;
  currentPage = 1;
  pageSize = 10

  dbName!: string;
  pageId!: string;
  documentId!: string;
  controlfield!: string;

  constructor(private route: ActivatedRoute,
    private dataSharingService: DataSharingService,
    private attributeValueService: AttributeValueService) {
    super();
  }

   override ngOnInit(): void {
    this.dbName = localStorage.getItem('dbname') as string;

    this.dataSharingService.tabIdChanges$.subscribe({
      next: (pageId: any) => {
        this.pageId = pageId;
      }
    });

    this.documentId = localStorage.getItem('doc-id') as string;

    this.pageId = localStorage.getItem('page-id') as string;

    this.attributeValueService.loadCurrentAttributeValue('', this.documentId, this.pageId, this.currentPage, this.pageSize, this.dbName).subscribe({
      next: (currentAttributeValueDto: { controlData: string; }) => {
        JSON.parse(currentAttributeValueDto.controlData);
      },
      //error: error => this.errorMessage = ErrorFormat.formatError(error)
    });
  }

  valueChangeFn(key: any, id: any, event: MatSlideToggleChange) {

    let formData:any = {};
    
    formData[key] = event.checked;
    console.log(id);

    this.attributeValueService.createAttributValueInfo(this.documentId, this.pageId, formData, key, id, this.dbName).subscribe({
      next: (x: any) => {
        console.log(x)
      },
      // error: error => this.errorMessage = ErrorFormat.formatError(error)
    });
  }
}
